import { Component, OnInit } from "@angular/core";
import {DomSanitizer, SafeResourceUrl} from "@angular/platform-browser";
import {environment} from "../../../../environments/environment";

@Component({
  selector: "ubt-geods-training-center",
  templateUrl: "./training-center.component.html",
  styleUrls: ["./training-center.component.scss"],
})
export class TrainingCenterComponent implements OnInit {
  public iframeSrc: SafeResourceUrl;

  constructor(private sanitizer: DomSanitizer) {
  }

  ngOnInit(): void {
    this.iframeSrc = this.sanitizer.bypassSecurityTrustResourceUrl(environment.webKioskUrl);

  }
}
